import { Component, OnInit } from '@angular/core';
import { Device } from 'src/app/models/data/device';
import { ApiService } from 'src/app/services/api.services';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import { CardsComponent } from '../../../components/cards/cards.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-device-lookup',
	templateUrl: './device-lookup.component.html',
	styleUrls: ['./device-lookup.component.scss', '../../common/main.scss'],
	imports: [
		CardsComponent,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		MatButton,
	],
})
export class DeviceLookupComponent implements OnInit {
	public device?: Device;
	public serialNumber?: string;
	public message = '';
	public isOracle = false;

	constructor(
		private readonly apiService: ApiService,
		private readonly scService: SystemCapabilityService
	) {}

	ngOnInit(): void {
		this.isOracle = this.scService.isOracle;
	}

	async lookupDevice(): Promise<void> {
		this.message = '';
		this.device = undefined;

		if (!this.serialNumber) {
			this.message = 'Enter serial number and click "Lookup Device"';
			return;
		}

		try {
			this.device = await this.apiService.getDeviceBySerialNumber(
				this.serialNumber
			);
		} catch (err: any) {
			console.error('Error: ', err);
			this.device = undefined;
			this.message = `An error occurred while getting the device: ${err.errors[0]}`;
			return;
		}
		if (!this.device) {
			this.message = `No device found for serial number: ${this.serialNumber}`;
			return;
		}
	}
}
